import {} from "../../request/api";
const state = {
    // 云象图层
    cloudMap: {
        iconGroup: new L.layerGroup(), //图标图层
        proGroup: new L.layerGroup(), //色斑图层
        windGroup: new L.layerGroup(), //风图层
    },
    adsbMap: {
        iconGroup: new L.layerGroup(null, {}), //飞机
        stationGroup: new L.layerGroup(null, {}), //基站
        locusGroup: new L.layerGroup(null, {}), //轨迹
        followGroup: new L.layerGroup(null, {}), //关注
        wakeGroup: new L.layerGroup(null, {}), //尾迹
    },
    newMap: {
        newGroup: new L.layerGroup(),
        CustomGroup: new L.layerGroup(),
        positionGroup: new L.layerGroup([], {
            pane: 'das'
        }),
        positionGroup1: new L.layerGroup(),
        positionGroup2: new L.layerGroup(),

    },
    alarmMap: {
        ORDINARYGroup: new L.layerGroup(),
        LIMITEDGroup: new L.layerGroup(),
        NOFLYGroup: new L.layerGroup(),
        CONFLICTGroup: new L.layerGroup(),

    },
    // 添加
    areaMap: {
        CONTROLGroup: new L.layerGroup(),
        MONITORGroup: new L.layerGroup(),
        REPORTGroup: new L.layerGroup(),
    },
    boundMap: {
        citiesInfoGroup_top: new L.layerGroup(null, {}),
        provinceInfoGroup_top: new L.layerGroup(null, {}),
    },
    routerMap: {
        lineGroup: new L.layerGroup(null, {}),
        routerGroup: new L.layerGroup(null, {}),
    },
    controlMap: {
        controlGroup: new L.layerGroup(null, {}),
        ControlRoomGroup: new L.layerGroup(),
    },
    lowAltMap: {
        lowAltGroup: new L.layerGroup(null, {}),
    }

};
const mutations = {
    changeMap(state) {
        state.cloudMap.iconGroup.addTo(map);
        state.cloudMap.proGroup.addTo(map);
        state.cloudMap.windGroup.addTo(map);
        state.adsbMap.iconGroup.addTo(map);
        state.adsbMap.stationGroup.addTo(map);
        state.adsbMap.locusGroup.addTo(map);
        state.adsbMap.followGroup.addTo(map);
        state.adsbMap.wakeGroup.addTo(map);

        state.newMap.newGroup.addTo(map);
        state.newMap.CustomGroup.addTo(map);
        state.newMap.positionGroup.addTo(map);
        state.newMap.positionGroup1.addTo(map);
        state.newMap.positionGroup2.addTo(map);

        state.alarmMap.ORDINARYGroup.addTo(map);
        state.alarmMap.LIMITEDGroup.addTo(map);
        state.alarmMap.NOFLYGroup.addTo(map);
        state.alarmMap.CONFLICTGroup.addTo(map);


        // 添加
        state.areaMap.CONTROLGroup.addTo(map)
        state.areaMap.MONITORGroup.addTo(map)
        state.areaMap.REPORTGroup.addTo(map)

        state.boundMap.citiesInfoGroup_top.addTo(map);
        state.boundMap.provinceInfoGroup_top.addTo(map);

        state.routerMap.lineGroup.addTo(map);
        state.routerMap.routerGroup.addTo(map);

        state.controlMap.controlGroup.addTo(map);
        state.controlMap.ControlRoomGroup.addTo(map);

        state.lowAltMap.lowAltGroup.addTo(map);
    },

};
const actions = {
    initMapDataAction(context) {
        context.commit('changeMap');
    },
};

const getters = {
    cloudMap(state) {
        return state.cloudMap;
    },
    adsbMap(state) {
        return state.adsbMap
    },
    newMap(state) {
        return state.newMap
    },
    alarmMap(state) {
        return state.alarmMap
    },
    // 添加
    areaMap(state) {
        return state.areaMap
    },
    boundMap(state) {
        return state.boundMap
    },
    routerMap(state) {
        return state.routerMap
    },
    controlMap(state) {
        return state.controlMap
    },
    lowAltMap(state) {
        return state.lowAltMap
    },

};

export default {
    state,
    mutations,
    actions,
    getters,
    // 命名空间
    namespaced: true, //使用命名空间
}